import * as React from 'react';
import { Canceler } from 'axios';
import { DraggableLocation } from 'react-beautiful-dnd';

import { ITableRowValue } from '../components/TableRow';
import {
  IGroup,
  IItemGroupsProps,
  IItemGroupsState,
  IItemGroupId,
} from './types';
import { IItem } from '../Items/types';

import API from 'src/services/api';
import EditForm from './components/EditForm';
import Subpage from '../components/Subpage';
import { mapGroup } from './services/mapGroup';
import { moveItem } from './services/moveItem';
import { removeGroup } from './services/removeGroup';
import { addGroup } from './services/addGroup';
import { prepareItemsAndGroups } from './services/prepareItemsAndGroups';

export default class ItemGroups extends React.Component<
  IItemGroupsProps,
  IItemGroupsState
> {
  reqCancelers: Canceler[] = [];
  newIdCounter = 1;

  state: IItemGroupsState = {
    groups: [],
    items: {},
    isLoading: true,
  };

  async componentDidMount() {
    const requests = [API.ADMIN.ITEM_GROUPS.getAll(), API.ADMIN.ITEMS.getAll()];
    this.reqCancelers = requests.map((req) => req.cancel);
    const [allGroups, allItems] = await Promise.all(
      requests.map((req) => req.getData()) as [
        Promise<IGroup[]>,
        Promise<IItem[]>
      ]
    );
    this.reqCancelers = [];

    this.setState({
      isLoading: false,
      ...prepareItemsAndGroups(allItems, allGroups),
    });
  }
  componentWillUnmount() {
    this.reqCancelers.forEach((cancel) => cancel());
  }

  columns: ITableRowValue[] = ['Parameter', 'Group count'];

  getColumnValues = (group: IGroup) => [
    group.parameter.name,
    group.itemGroups.length,
  ];

  getSearchString = (group: IGroup) => group.parameter.name;

  setGroupName =
    (parameterId: number) => (id: IItemGroupId) => (name: string) => {
      this.setState(({ groups }) => ({
        groups: mapGroup({
          groups,
          parameterId,
          itemId: id,
          callback: (itemGroup) => ({
            ...itemGroup,
            name,
          }),
        }),
      }));
    };

  toggleGroupExpand = (parameterId: number) => (id: IItemGroupId) => () => {
    this.setState(({ groups }) => ({
      groups: mapGroup({
        groups,
        parameterId,
        itemId: id,
        callback: (itemGroup) => ({
          ...itemGroup,
          isExpanded: !itemGroup.isExpanded,
        }),
      }),
    }));
  };

  setAllGroupsExpand = (parameterId: number) => (isExpanded: boolean) => {
    this.setState((state) => ({
      groups: state.groups.map((group) => {
        if (group.parameter.id === parameterId) {
          return {
            ...group,
            itemGroups: group.itemGroups.map((itemGroup) => ({
              ...itemGroup,
              isExpanded,
            })),
          };
        }
        return group;
      }),
    }));
  };

  moveGroup = (parameterId: number) => (fromIndex: number, toIndex: number) => {
    this.setState((state) => ({
      groups: state.groups.map((group) => {
        if (group.parameter.id === parameterId) {
          const itemGroupsCopy = [...group.itemGroups];
          const [movedGroup] = itemGroupsCopy.splice(fromIndex, 1);
          itemGroupsCopy.splice(toIndex, 0, movedGroup);
          return {
            ...group,
            itemGroups: itemGroupsCopy,
          };
        }
        return group;
      }),
    }));
  };

  moveItem =
    (parameterId: number) =>
    (from: DraggableLocation, to: DraggableLocation) => {
      this.setState((state) => ({
        ...state,
        ...moveItem({
          items: state.items,
          groups: state.groups,
          parameterId,
          from,
          to,
        }),
      }));
    };

  addItemGroup = (parameterId: number) => () => {
    this.newIdCounter++;
    this.setState((state) => ({
      ...state,
      ...addGroup({
        groups: state.groups,
        parameterId,
        newIdCounter: this.newIdCounter,
      }),
    }));
  };

  removeItemGroup = (parameterId: number) => (id: IItemGroupId) => () => {
    console.log(parameterId, id);
    this.setState((state) => ({
      ...state,
      ...removeGroup({
        items: state.items,
        groups: state.groups,
        parameterId,
        groupId: id,
      }),
    }));
  };

  update = (parameterId: number) => async () => {
    const group = this.state.groups.find((g) => g.parameter.id === parameterId);
    if (group) {
      await API.ADMIN.ITEM_GROUPS.update(group);
    }
  };

  EditForm = ({ item, ...props }: any) => {
    const items = this.state.items[item.parameter.id];
    const noItemGroups = item.itemGroups.length === 0;
    if (!items && noItemGroups) {
      return <p className="p-6">This parameter has no items!</p>;
    }
    return (
      <EditForm
        onSave={this.update(item.parameter.id)}
        group={item}
        items={items || []}
        addGroup={this.addItemGroup(item.parameter.id)}
        removeGroup={this.removeItemGroup(item.parameter.id)}
        moveGroup={this.moveGroup(item.parameter.id)}
        moveItem={this.moveItem(item.parameter.id)}
        setGroupName={this.setGroupName(item.parameter.id)}
        toggleGroupExpand={this.toggleGroupExpand(item.parameter.id)}
        setAllGroupsExpand={this.setAllGroupsExpand(item.parameter.id)}
        {...props}
      />
    );
  };

  render() {
    return (
      <Subpage
        currentPath={this.props.location.pathname}
        EditForm={this.EditForm}
        columns={this.columns}
        getColumnValues={this.getColumnValues}
        getSearchString={this.getSearchString}
        items={this.state.groups}
        isLoading={this.state.isLoading}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/ItemGroups.tsx